import React, { ReactElement } from "react";
import styles from "./notFoundUI.module.scss";
import NotFoundIcon from "@icons/notFoundIcon.svg";

export const NotFoundUI = (props: Props): ReactElement => {
  const handleBackClicked = (e: any) => {
    e.preventDefault();
    try {
      window.history.back();
    } catch (error) {
      return;
    }
  };

  return (
    <div className={styles.layout}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.headingAndSubheading}>
            <p className={styles.label}>{props.label}</p>
            <p className={styles.title}>{props.title}</p>
          </div>
          <p className={styles.desc}>{props.desc}</p>
          <div className={styles.buttons}>
            <button className={styles.backButton} onClick={handleBackClicked}>
              {props.backButtonLabel}
            </button>
            <a className={styles.homeButton} href="/">
              {props.homeButtonLabel}
            </a>
          </div>
        </div>
        <div className={styles.illustration}>
          <NotFoundIcon />
        </div>
      </div>
    </div>
  );
};

interface Props {
  title: string;
  label: string;
  homeButtonLabel: string;
  backButtonLabel: string;
  desc: string;
}
